require('./bootstrap')

document.addEventListener('DOMContentLoaded', setLiveClock)

function setLiveClock() {
	liveClock = document.querySelector('#live-clock')
	if (liveClock) {
		setInterval(function () {
			const time = new Date()
			liveClock.innerText = `${makeTwoDigitNumber(time.getHours())}:${makeTwoDigitNumber(time.getMinutes())}:${makeTwoDigitNumber(time.getSeconds())}`
		}, 1000)
	}
}


function makeTwoDigitNumber(number) {
	if (number / 10 < 1) {
		return '0' + number
	}
	return number
}